export default "__VITE_ASSET__DPcir3S3__"